// Memoize return values of a function with first in first out.
export function memoizeFIFO(func, { size = 3 } = {}) {
  if (!window.store) {
    window.store = new Map();
  }
  const store = window.store;

  return function (key) {
    if (store.has(key)) {
      return store.get(key);
    }

    if (store.size >= size) {
      const oldestKey = store.keys().next().value;
      store.delete(oldestKey);
    }

    const value = func(key);
    store.set(key, value);
    return value;
  }
}
